import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { RoadMaintenanceOverviewFieldsFragment } from 'api/graphql-types';
import { setRoadMaintenanceOverviewItems, setTotalRoadMaintenance } from 'redux/stores/road-maintenance';
import { useAppSelector } from 'redux/store';
import { Typography } from 'components/typography';
import { Card } from 'components/card/card';

import { searchRoadMaintenance } from 'api/algolia';

import styles from './road-maintenance-overview.module.scss';

export interface IRoadMaintenanceOverviewProps {
	module?: RoadMaintenanceOverviewFieldsFragment;
}

export const RoadMaintenanceOverview = ({ module }: IRoadMaintenanceOverviewProps): React.JSX.Element => {
	const router = useRouter();
	const intl = useIntl();
	const dispatch = useDispatch();
	const { roadMaintenancesCount, roadMaintenances } = useAppSelector((state) => state.roadMaintenance);

	const getRoadMaintenanceData = async (): Promise<void> => {
		const { results: newRoadMaintenances, total: newTotalRoadMaintenances } = await searchRoadMaintenance('', {
			page: 1,
			limit: 9999,
			locale: router.locale
		});

		dispatch(setRoadMaintenanceOverviewItems(newRoadMaintenances));
		dispatch(setTotalRoadMaintenance(newTotalRoadMaintenances));
	};

	useEffect(() => {
		getRoadMaintenanceData();
	}, []);

	return (
		<section className={styles.container}>
			<div className={styles.header}>
				<Typography tag="h2" variant="h3">
					{module?.title || intl.formatMessage({ id: 'modules.roadMaintenance.overview.title' })}
				</Typography>
				<div className={styles.results}>
					{intl.formatMessage({ id: 'global.results' }, { results: roadMaintenancesCount })}
				</div>
			</div>

			{roadMaintenances && roadMaintenances.length > 0 && (
				<div className={styles.list}>
					{roadMaintenances.map(({ title, slug }, index) => (
						<Card key={index} title={title || ''} slug={slug} />
					))}
				</div>
			)}
		</section>
	);
};

export default RoadMaintenanceOverview;
